import React from 'react';
import { OrderDetailHero } from '../orderDetailsTypes';
import { OrderStatusBadge } from '../../shared';
import styles from './OrderHero.module.css';

interface OrderHeroProps {
  hero: OrderDetailHero;
}

export const OrderHero: React.FC<OrderHeroProps> = ({ hero }) => {
  return (
    <div className={styles.card}>
      <div className={styles.headerRow}>
        <div>
          <p className={styles.orderId}>{hero.orderId}</p>
          <p className={styles.customer}>Customer: {hero.customer}</p>
        </div>
        <div className={styles.metricsTop}>
          <div className={styles.metric}>
            <p className={styles.metricLabel}>Total Value</p>
            <p className={styles.metricValue}>{hero.totalValue}</p>
          </div>
          <div className={styles.metric}>
            <p className={styles.metricLabel}>Est. Profit</p>
            <p className={`${styles.metricValue} ${styles.profit}`}>{hero.estProfit}</p>
            <p className={styles.metricMargin}>{hero.marginPct}</p>
          </div>
        </div>
      </div>

      <div className={styles.statusRow}>
        <OrderStatusBadge status={hero.status} />
      </div>

      <div className={styles.metaGrid}>
        <div>
          <p className={styles.metaLabel}>📦 Total Items</p>
          <p className={styles.metaValue}>{hero.itemCount}</p>
        </div>
        <div>
          <p className={styles.metaLabel}>📅 Delivery Date</p>
          <p className={styles.metaValue}>{hero.deliveryDate}</p>
        </div>
        <div>
          <p className={styles.metaLabel}>💳 Payment</p>
          <p className={styles.metaValue}>{hero.paymentTerms}</p>
        </div>
        <div>
          <p className={styles.metaLabel}>$ Payment Status</p>
          <p className={`${styles.metaValue} ${styles.warning}`}>{hero.paymentStatus}</p>
        </div>
      </div>
    </div>
  );
};
